import request from '#api/axios';
import { queryKeyFactory } from '#api/queryKeyFactory';
import { IResponse } from '#types/api';
import {
  CreateCustomExerciseTypeDto,
  ICustomExerciseType,
  IGetIExerciseTypes
} from '#types/exerciseTypes';
import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const getExerciseTypes = async () => {
  const res = await request<IGetIExerciseTypes>({
    method: 'get',
    url: '/exercise-types',
    params: {
      page: 0,
      offset: 300 // TODO: 무한스크롤 적용
    }
  });

  return res.data;
};

export const useGetExerciseTypes = (
  options?: UseQueryOptions<
    IGetIExerciseTypes,
    AxiosError,
    IGetIExerciseTypes,
    string[]
  >
) => {
  return useQuery(
    queryKeyFactory.GET_EXERCISE_TYPES(),
    getExerciseTypes,
    options
  );
};

export const getCustomExerciseTypes = async () => {
  const res = await request<IResponse<ICustomExerciseType>>({
    method: 'get',
    url: '/exercise-types/custom',
    params: {
      page: 0,
      offset: 300
    }
  });

  return res.data;
};

export const useGetCustomExerciseTypes = () => {
  return useQuery(
    queryKeyFactory.GET_CUSTOM_EXERCISE_TYPES(),
    getCustomExerciseTypes
  );
};

export const postCustomExerciseType = async (
  param: CreateCustomExerciseTypeDto
) => {
  const res = await request<CreateCustomExerciseTypeDto>({
    method: 'post',
    url: '/exercise-types/custom',
    data: param
  });

  return res.data;
};

export const usePostCustomExerciseType = (
  options?: UseMutationOptions<unknown, AxiosError, CreateCustomExerciseTypeDto>
) => {
  return useMutation(postCustomExerciseType, options);
};

export const getExerciseTypesSearch = async ({ name }: { name: string }) => {
  const res = await request<ICustomExerciseType[]>({
    method: 'get',
    url: '/exercise-types/search',
    params: {
      name
    }
  });

  return res.data;
};

export const useGetExerciseTypesSearch = ({ name }: { name: string }) => {
  return useQuery(queryKeyFactory.GET_EXERCISE_TYPES_SEARCH(name), () =>
    getExerciseTypesSearch({ name })
  );
};
